import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'
import styles from './Tree.css'

const BasicFolderNodeRenderer = ({
    node,
    onClick,
    expanded,
    getName
  }) => {
  const clickHandler = () => onClick && onClick(node)
  return (
    <div className={styles.itemWrapper} onClick={clickHandler}>
      <Icon
        className={'tree-item-arrow'}
        size={25}
        name={expanded ? 'arrow-down' : 'arrow-up'}
      />
      <span className={styles.itemLabel}>
        {getName(node) || ''}
      </span>
    </div>
  )
}

BasicFolderNodeRenderer.propTypes = {
  node: PropTypes.object,
  onClick: PropTypes.func,
  expanded: PropTypes.bool,
  getName: PropTypes.func,
}

export default BasicFolderNodeRenderer



// WEBPACK FOOTER //
// ../src/components/Tree/BasicFolderNodeRenderer.js